import { render, staticRenderFns } from "./ReportingValue.vue?vue&type=template&id=1b39ae7d"
import script from "../../js/components/partials/ReportingValue.js?vue&type=script&lang=js&external"
export * from "../../js/components/partials/ReportingValue.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports